import SecurePaymentService from "../services/SecurePaymentService";
import {setLoderStatus} from "../actions/SecurePaymentActions";
import {showApiErrorMessage,showTnCErrorToast} from "../actions/ToastActions";

export const setCountryState = (countryStates) => {
    return {
        type: 'SET_COUNTRY_STATES',
        value : countryStates
    }
}
export const setCountryCurrency = (currencyCode) => {
    return {
        type: 'SET_COUNTRY_CURRENCY',
        value : currencyCode
    }
}

export const setCountry = (countryCode) =>{
    return{
        type:'SET_COUNTRY',
        value:countryCode
    }
};
export const setState = (stateCode) =>{
    return{
        type:'SET_STATE',
        value:stateCode
    }
};
export const setEventTermCondtion = (list) =>{
    return{
        type:'SET_EVENT_TERM_CONDITION',
        value:list
    }
};
export const setTermsConditionAccepted = (val) =>{	
    return{	
        type:'SET_TERM_CONDITION_ACCEPTED',	
        value:val	
    }	
};
export const setEventMiniWallet = (data) =>{
    return{
        type:'SET_EVENT_WALLET_APP',
        value:data
    }
};
export function loadCountryStateList(countryCode) {
    return function(dispatch) {
        dispatch(setLoderStatus(true));
        return SecurePaymentService.loadStateList(countryCode).then(response => {
            dispatch(setLoderStatus(false));
            dispatch(setCountryState(response.data['state-provinces']));
            dispatch(setCountryCurrency(response.data['supported-currencies']));
        })
        .catch(function (error) {
            dispatch(setLoderStatus(false));
            console.log('Error while loading config');
        });
    };
}

export function loadEventTermCondition() {
    
    return function(dispatch) {
        return SecurePaymentService.getEventTermCondition().then(response => {
            dispatch(setEventTermCondtion(response));
        })
        .catch(function (error) {
            console.log('Error while loading terms and condition event list');
        });
    };
}
export function loadEventTnCLog() {
    
    return function(dispatch) {
        return SecurePaymentService.getEventLogTermCondition().then(response => {
            dispatch(setEventTermCondtion(response));
            dispatch(showTnCErrorToast(false));
        })
        .catch(function (error) {
            console.log('Error while loading terms and condition event list');
            dispatch(showTnCErrorToast(true));
        });
    };
}



export function loadEventMiniWallet() {
    
    return function(dispatch) {
        return SecurePaymentService.getEventMiniWallet().then(response => {
            dispatch(setEventMiniWallet(response));
        })
        .catch(function (error) {
            dispatch(showApiErrorMessage(true));
            console.log('Error while loading wallet event list');
        });
    };
}